import { getCurrentWindow } from "../utils/window";

/**
 * 最终的兜底打开
 */
export function doUrlForDefaultOpen(theUrl, options) {
  var replace = options.replace,
      windowName = options.windowName,
      windowFeatures = options.windowFeatures,
      supportIFrame = options.supportIFrame;
  var currentWindow = getCurrentWindow(supportIFrame);

  if (replace) {
    var _currentWindow$locati;

    currentWindow === null || currentWindow === void 0 ? void 0 : (_currentWindow$locati = currentWindow.location) === null || _currentWindow$locati === void 0 ? void 0 : _currentWindow$locati.replace(theUrl);
  } else {
    currentWindow === null || currentWindow === void 0 ? void 0 : currentWindow.open(theUrl, windowName, windowFeatures);
  }
}